import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Box,
  Chip,
  Divider,
  Paper,
  IconButton,
  InputAdornment,
  Switch,
  FormControlLabel,
  Menu,
  MenuItem,
  FormControl,
  Avatar,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  AccessTime,
  Delete,
  MessageOutlined,
  MicOutlined,
  AttachFile,
  Timer,
  Add,
  ImportContacts,
  PhoneAndroid,
  MicNone,
  Videocam,
  InfoOutlined,
} from "@material-ui/icons";
import {
  ChatBubbleOutline,
  MusicNote,
  InsertDriveFileOutlined,
  CloudUpload,
  Image as ImageIcon,
  VideoCall as VideoIcon,
  InsertDriveFile,
} from "@mui/icons-material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
}));

const FlowBuilderAddActiveMessageModal = ({
  open,
  onSave,
  data,
  onUpdate,
  close,
  variables,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMounted = useRef(true);

  // Estados principais
  const [activeModal, setActiveModal] = useState(false);
  const [medias, setMedias] = useState([]);
  const [elements, setElements] = useState([]);
  const [elementsSeq, setElementsSeq] = useState([]);
  const [elementsSeqEdit, setElementsSeqEdit] = useState([]);
  const [elementsEdit, setElementsEdit] = useState([]);

  // Contadores de elementos
  const [numberMessages, setNumberMessages] = useState(0);
  const [numberMessagesLast, setNumberMessagesLast] = useState(0);
  const [numberInterval, setNumberInterval] = useState(0);
  const [numberIntervalLast, setNumberIntervalLast] = useState(0);
  const [numberAudio, setNumberAudio] = useState(0);
  const [numberAudioLast, setNumberAudioLast] = useState(0);
  const [numberVideo, setNumberVideo] = useState(0);
  const [numberVideoLast, setNumberVideoLast] = useState(0);
  const [numberImg, setNumberImg] = useState(0);
  const [numberImgLast, setNumberImgLast] = useState(0);
  const [numberFile, setNumberFile] = useState(0);
  const [numberFileLast, setNumberFileLast] = useState(0);

  // Estados de mídia
  const [loading, setLoading] = useState(false);
  const [previewImg, setPreviewImg] = useState([]);
  const [previewAudios, setPreviewAudios] = useState([]);
  const [previewVideos, setPreviewVideos] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);

  // Estados específicos da Mensagem Ativa
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [phoneNumberInput, setPhoneNumberInput] = useState("");
  const [groupName, setGroupName] = useState("");
  const [useGroup, setUseGroup] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [whatsappConnections, setWhatsappConnections] = useState([]);
  const [selectedWhatsappId, setSelectedWhatsappId] = useState(undefined);

  // Tags
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [loadingTags, setLoadingTags] = useState(false);

  const [labels, setLabels] = useState({
    title: "Adicionar mensagem ativa",
    btn: "Adicionar",
  });

  const [mediaMenuAnchor, setMediaMenuAnchor] = useState(null);

  // Backend URL
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const companyId = localStorage.getItem("companyId");

  // Inicialização
  useEffect(() => {
    if (open) {
      setActiveModal(true);

      // Carregar conexões WhatsApp
      const fetchWhatsAppConnections = async () => {
        try {
          const { data } = await api.get("/whatsapp");
          setWhatsappConnections(data);
        } catch (error) {
          console.error("Erro ao buscar conexões WhatsApp:", error);
        }
      };

      // Carregar tags
      const fetchTags = async () => {
        setLoadingTags(true);
        try {
          const { data } = await api.get("/tags/list", {
            params: { kanban: 0 },
          });
          setTags(data);
        } catch (error) {
          console.error("Erro ao buscar tags:", error);
        } finally {
          setLoadingTags(false);
        }
      };

      fetchWhatsAppConnections();
      fetchTags();

      if (open === "edit" && data) {
        setLabels({
          title: "Editar mensagem ativa",
          btn: "Atualizar",
        });

        const nodeData = data?.data || {};
        setElementsSeq([...(nodeData.seq || [])]);
        setElementsSeqEdit([...(nodeData.seq || [])]);
        setElementsEdit([...(nodeData.elements || [])]);
        setPhoneNumbers(nodeData.phoneNumbers || []);
        setGroupName(nodeData.groupName || "");
        setUseGroup(!!nodeData.groupName);
        setSelectedWhatsappId(nodeData.whatsappId);

        // Configurar elementos
        let msgCount = 0,
          intervalCount = 0,
          imgCount = 0,
          audioCount = 0,
          videoCount = 0,
          fileCount = 0;
        const elementsArray = [];
        const previewImgArray = [];
        const previewAudiosArray = [];
        const previewVideosArray = [];
        const previewFilesArray = [];

        (nodeData.seq || []).forEach((item) => {
          const elementData = (nodeData.elements || []).find(
            (el) => el.number === item
          );

          if (item.includes("message")) {
            const number = parseInt(item.replace("message", ""), 10);
            msgCount = Math.max(msgCount, number);
            elementsArray.push(messageLayout(number, elementData?.value || ""));
          } else if (item.includes("interval")) {
            const number = parseInt(item.replace("interval", ""), 10);
            intervalCount = Math.max(intervalCount, number);
            elementsArray.push(
              intervalLayout(number, elementData?.value || "1")
            );
          } else if (item.includes("img")) {
            const number = parseInt(item.replace("img", ""), 10);
            imgCount = Math.max(imgCount, number);
            elementsArray.push(imgLayout(number, elementData?.value || ""));
            if (elementData?.value) {
              previewImgArray.push({ number, url: "", name: elementData.value });
            }
          } else if (item.includes("audio")) {
            const number = parseInt(item.replace("audio", ""), 10);
            audioCount = Math.max(audioCount, number);
            elementsArray.push(
              audioLayout(
                number,
                elementData?.value || "",
                elementData?.record || false
              )
            );
            if (elementData?.value) {
              previewAudiosArray.push({
                number,
                url: "",
                name: elementData.value,
              });
            }
          } else if (item.includes("video")) {
            const number = parseInt(item.replace("video", ""), 10);
            videoCount = Math.max(videoCount, number);
            elementsArray.push(videoLayout(number, elementData?.value || ""));
            if (elementData?.value) {
              previewVideosArray.push({
                number,
                url: "",
                name: elementData.value,
              });
            }
          } else if (item.includes("file")) {
            const number = parseInt(item.replace("file", ""), 10);
            fileCount = Math.max(fileCount, number);
            elementsArray.push(fileLayout(number, elementData?.value || ""));
            if (elementData?.value) {
              previewFilesArray.push({
                number,
                url: "",
                name: elementData.value,
              });
            }
          }
        });

        setElements(elementsArray);
        setPreviewImg(previewImgArray);
        setPreviewAudios(previewAudiosArray);
        setPreviewVideos(previewVideosArray);
        setPreviewFiles(previewFilesArray);
        setNumberMessages(msgCount + 1);
        setNumberMessagesLast(msgCount + 1);
        setNumberInterval(intervalCount + 1);
        setNumberIntervalLast(intervalCount + 1);
        setNumberImg(imgCount + 1);
        setNumberImgLast(imgCount + 1);
        setNumberAudio(audioCount + 1);
        setNumberAudioLast(audioCount + 1);
        setNumberVideo(videoCount + 1);
        setNumberVideoLast(videoCount + 1);
        setNumberFile(fileCount + 1);
        setNumberFileLast(fileCount + 1);
      } else {
        resetState();
      }
    }
  }, [open, data]);

  // Configurar tags selecionadas
  useEffect(() => {
    if (tags.length > 0 && open === "edit" && data && data.data?.tagIds) {
      const selectedTagsFromData = tags.filter((tag) =>
        data.data.tagIds.includes(tag.id)
      );
      setSelectedTags(selectedTagsFromData);
    }
  }, [tags, data, open]);

  // Cleanup
  useEffect(() => {
    return () => {
      [...previewImg, ...previewAudios, ...previewVideos, ...previewFiles].forEach(
        (p) => URL.revokeObjectURL(p.url)
      );
    };
  }, [previewImg, previewAudios, previewVideos, previewFiles]);

  // Buscar contatos
  const searchContacts = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 3) return;

    setLoadingContacts(true);
    try {
      const { data } = await api.get("/contacts", {
        params: { searchParam: searchTerm },
      });
      setContacts(data.contacts || []);
    } catch (error) {
      console.error("Erro ao buscar contatos:", error);
    } finally {
      setLoadingContacts(false);
    }
  };

  // Formatar numero
  const formatPhoneNumber = (number) => {
    let digits = number.replace(/\D/g, "");
    if (digits.length === 11 || digits.length === 10) {
      digits = "55" + digits;
    }
    if (digits.length < 10) {
      return "";
    }
    return digits;
  };

  // Adicionar numero
  const addPhoneNumber = () => {
    if (selectedContact) {
      const formattedNumber = formatPhoneNumber(selectedContact.number);
      if (!formattedNumber) {
        toast.error("Numero de telefone invalido");
        return;
      }
      if (phoneNumbers.includes(formattedNumber)) {
        toast.error("Este numero ja foi adicionado");
        return;
      }
      setPhoneNumbers([...phoneNumbers, formattedNumber]);
      setSelectedContact(null);
      setPhoneNumberInput("");
    } else if (phoneNumberInput) {
      const formattedNumber = formatPhoneNumber(phoneNumberInput);
      if (!formattedNumber) {
        toast.error("Numero de telefone invalido");
        return;
      }
      if (phoneNumbers.includes(formattedNumber)) {
        toast.error("Este numero ja foi adicionado");
        return;
      }
      setPhoneNumbers([...phoneNumbers, formattedNumber]);
      setPhoneNumberInput("");
    }
  };

  // Remover numero
  const removePhoneNumber = (number) => {
    setPhoneNumbers(phoneNumbers.filter((n) => n !== number));
  };

  // Importar numeros
  const importPhoneNumbers = (event) => {
    if (!event.target.files || event.target.files.length === 0) return;

    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const content = e.target?.result;
      const lines = content.split(/\r\n|\n|\r/).filter((line) => line.trim());

      const newNumbers = [];
      const invalidNumbers = [];

      lines.forEach((line) => {
        const number = formatPhoneNumber(line.trim());
        if (
          number &&
          !phoneNumbers.includes(number) &&
          !newNumbers.includes(number)
        ) {
          newNumbers.push(number);
        } else if (!number) {
          invalidNumbers.push(line.trim());
        }
      });

      if (newNumbers.length > 0) {
        setPhoneNumbers([...phoneNumbers, ...newNumbers]);
        toast.success(`${newNumbers.length} numeros adicionados`);
      }

      if (invalidNumbers.length > 0) {
        toast.warning(`${invalidNumbers.length} numeros invalidos foram ignorados`);
      }
    };

    reader.readAsText(file);
    event.target.value = "";
  };

  // Reset state
  const resetState = () => {
    setElements([]);
    setElementsSeq([]);
    setElementsSeqEdit([]);
    setElementsEdit([]);
    setNumberMessages(0);
    setNumberMessagesLast(0);
    setNumberInterval(0);
    setNumberIntervalLast(0);
    setNumberImg(0);
    setNumberImgLast(0);
    setNumberAudio(0);
    setNumberAudioLast(0);
    setNumberVideo(0);
    setNumberVideoLast(0);
    setNumberFile(0);
    setNumberFileLast(0);
    setPreviewImg([]);
    setPreviewAudios([]);
    setPreviewVideos([]);
    setPreviewFiles([]);
    setMedias([]);
    setPhoneNumbers([]);
    setPhoneNumberInput("");
    setGroupName("");
    setUseGroup(false);
    setSelectedWhatsappId(undefined);
    setSelectedTags([]);
    setLabels({
      title: "Adicionar mensagem ativa",
      btn: "Adicionar",
    });
  };

  // Fechar modal
  const handleClose = () => {
    setActiveModal(false);
    close(null);
    resetState();
  };

  // Remover elemento
  const handleRemoveElement = (type, id) => {
    const elementId = `${type}${id}`;

    const filteredSeq = elementsSeq.filter((seq) => seq !== elementId);
    const filteredElements = elements.filter((_, index) => {
      return filteredSeq.includes(elementsSeq[index]);
    });

    setElementsSeq(filteredSeq);
    setElements(filteredElements);

    if (open === "edit") {
      const filteredSeqEdit = elementsSeqEdit.filter((seq) => seq !== elementId);
      const filteredElementsEdit = elementsEdit.filter(
        (el) => el.number !== elementId
      );
      setElementsSeqEdit(filteredSeqEdit);
      setElementsEdit(filteredElementsEdit);
    }

    // Atualizar previews
    switch (type) {
      case "img":
        setPreviewImg((prev) => prev.filter((item) => item.number !== id));
        break;
      case "audio":
        setPreviewAudios((prev) => prev.filter((item) => item.number !== id));
        break;
      case "video":
        setPreviewVideos((prev) => prev.filter((item) => item.number !== id));
        break;
      case "file":
        setPreviewFiles((prev) => prev.filter((item) => item.number !== id));
        break;
      default:
        break;
    }
  };

  // Handler de arquivo
  const handleFileChange = (e, type, number) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const file = e.target.files[0];

    let isValid = true;
    let maxSize = 10 * 1024 * 1024;

    if (type === "img") {
      isValid = file.type.startsWith("image/");
    } else if (type === "audio") {
      isValid = file.type.startsWith("audio/");
      maxSize = 5 * 1024 * 1024;
    } else if (type === "video") {
      isValid = file.type.startsWith("video/");
      maxSize = 20 * 1024 * 1024;
    } else if (type === "file") {
      const ext = file.name.split(".").pop()?.toLowerCase();
      isValid = ["pdf", "doc", "docx", "xls", "xlsx", "txt", "csv", "zip"].includes(
        ext
      );
    }

    if (!isValid) {
      toast.error("Tipo de arquivo invalido");
      return;
    }

    if (file.size > maxSize) {
      toast.error(`Arquivo muito grande. Maximo: ${maxSize / (1024 * 1024)}MB`);
      return;
    }

    const objectUrl = URL.createObjectURL(file);

    // Atualizar preview
    const setPreviewState =
      type === "img"
        ? setPreviewImg
        : type === "audio"
        ? setPreviewAudios
        : type === "video"
        ? setPreviewVideos
        : setPreviewFiles;

    setPreviewState((prevState) => {
      const filteredState = prevState.filter((item) => item.number !== number);
      return [...filteredState, { number, url: objectUrl, name: file.name }];
    });

    setMedias((prevMedias) => {
      const filteredMedias = prevMedias.filter((media) => media.name !== file.name);
      return [...filteredMedias, file];
    });

    toast.success(`Arquivo "${file.name}" selecionado`);
    e.target.value = "";
  };

  // Layouts de elementos
  const messageLayout = (number, valueDefault = "") => {
    return (
      <div
        key={`message-${number}`}
        className={`stackMessage${number}`}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          backgroundColor:
            theme.palette.type === "dark"
              ? "rgba(255, 255, 255, 0.05)"
              : "rgba(0, 0, 0, 0.03)",
          padding: "16px",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <div style={{ flex: 1 }}>
          <Typography
            variant="subtitle2"
            style={{ fontWeight: 500, marginBottom: "8px" }}
          >
            Mensagem
          </Typography>
          <TextField
            className={`message${number}`}
            placeholder="Digite sua mensagem aqui..."
            multiline
            rows={3}
            defaultValue={valueDefault}
            fullWidth
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ChatBubbleOutline fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <IconButton
          onClick={() => handleRemoveElement("message", number)}
          style={{ padding: "4px" }}
        >
          <Delete style={{ fontSize: "16px" }} />
        </IconButton>
      </div>
    );
  };

  const intervalLayout = (number, valueDefault = "1") => {
    return (
      <div
        key={`interval-${number}`}
        className={`stackInterval${number}`}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          backgroundColor:
            theme.palette.type === "dark"
              ? "rgba(255, 255, 255, 0.05)"
              : "rgba(0, 0, 0, 0.03)",
          padding: "16px",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <div style={{ flex: 1 }}>
          <Typography
            variant="subtitle2"
            style={{ fontWeight: 500, marginBottom: "8px" }}
          >
            Intervalo (segundos)
          </Typography>
          <TextField
            className={`interval${number}`}
            type="number"
            defaultValue={valueDefault}
            fullWidth
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccessTime fontSize="small" color="action" />
                </InputAdornment>
              ),
              inputProps: { min: 1, max: 120 },
            }}
          />
        </div>
        <IconButton
          onClick={() => handleRemoveElement("interval", number)}
          style={{ padding: "4px" }}
        >
          <Delete style={{ fontSize: "16px" }} />
        </IconButton>
      </div>
    );
  };

  const imgLayout = (number, valueDefault = "") => {
    const currentPreview = previewImg.find((p) => p.number === number);
    const fileName = currentPreview?.name || valueDefault;
    let imageUrl = undefined;

    if (currentPreview?.url?.startsWith("blob:")) {
      imageUrl = currentPreview.url;
    } else if (fileName && backendUrl && companyId) {
      imageUrl = `${backendUrl}/public/company${companyId}/${fileName}`;
    }

    return (
      <div
        key={`img-${number}`}
        className={`stackImg${number}`}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          backgroundColor:
            theme.palette.type === "dark"
              ? "rgba(255, 255, 255, 0.05)"
              : "rgba(0, 0, 0, 0.03)",
          padding: "16px",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <Typography variant="subtitle2" style={{ fontWeight: 500 }}>
            Imagem
          </Typography>
          <IconButton
            onClick={() => handleRemoveElement("img", number)}
            style={{ padding: "4px" }}
          >
            <Delete style={{ fontSize: "16px" }} />
          </IconButton>
        </div>

        <input
          accept="image/*"
          id={`imgFile${number}`}
          type="file"
          style={{ display: "none" }}
          onChange={(e) => handleFileChange(e, "img", number)}
        />

        <Box style={{ display: "flex", justifyContent: "center" }}>
          <label htmlFor={`imgFile${number}`} style={{ cursor: "pointer" }}>
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={fileName || "Preview"}
                style={{
                  maxWidth: "100%",
                  maxHeight: "200px",
                  display: "block",
                  margin: "0 auto",
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: "4px",
                }}
              />
            ) : (
              <Avatar
                variant="rounded"
                style={{
                  width: 128,
                  height: 128,
                  backgroundColor: theme.palette.action.hover,
                  border: `1px solid ${theme.palette.divider}`,
                }}
              >
                <ImageIcon
                  style={{
                    color: theme.palette.action.active,
                    width: 64,
                    height: 64,
                  }}
                />
              </Avatar>
            )}
          </label>
        </Box>
        <Typography variant="caption" align="center" style={{ marginTop: "8px" }}>
          {fileName || "Clique para selecionar uma imagem"}
        </Typography>
      </div>
    );
  };

  const audioLayout = (number, valueDefault = "", valueRecordDefault = false) => {
    const currentPreview = previewAudios.find((p) => p.number === number);
    const fileName = currentPreview?.name || valueDefault;
    let audioSrc = undefined;

    if (currentPreview?.url?.startsWith("blob:")) {
      audioSrc = currentPreview.url;
    } else if (fileName && backendUrl && companyId) {
      audioSrc = `${backendUrl}/public/company${companyId}/${fileName}`;
    }

    return (
      <div
        key={`audio-${number}`}
        className={`stackAudio${number}`}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          backgroundColor:
            theme.palette.type === "dark"
              ? "rgba(255, 255, 255, 0.05)"
              : "rgba(0, 0, 0, 0.03)",
          padding: "16px",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <Typography variant="subtitle2" style={{ fontWeight: 500 }}>
              Audio
            </Typography>
            <IconButton
              onClick={() => handleRemoveElement("audio", number)}
              style={{ padding: "4px" }}
            >
              <Delete style={{ fontSize: "16px" }} />
            </IconButton>
          </div>

          <input
            accept="audio/*"
            id={`audioFile${number}`}
            type="file"
            style={{ display: "none" }}
            onChange={(e) => handleFileChange(e, "audio", number)}
          />

          {audioSrc ? (
            <audio controls src={audioSrc} style={{ width: "100%" }} />
          ) : (
            <Box textAlign="center">
              <label htmlFor={`audioFile${number}`}>
                <Button
                  component="span"
                  variant="outlined"
                  size="small"
                  startIcon={<MusicNote />}
                >
                  Selecionar Audio
                </Button>
              </label>
            </Box>
          )}

          <Typography
            variant="caption"
            style={{ marginTop: "8px", display: "block" }}
          >
            {fileName || "Nenhum arquivo selecionado"}
          </Typography>

          <FormControlLabel
            control={
              <Switch
                className={`checkaudio${number}`}
                defaultChecked={valueRecordDefault}
                size="small"
              />
            }
            label="Simular Gravacao"
            style={{ marginTop: "8px" }}
          />
        </div>
      </div>
    );
  };

  const videoLayout = (number, valueDefault = "") => {
    const currentPreview = previewVideos.find((p) => p.number === number);
    const fileName = currentPreview?.name || valueDefault;
    let videoSrc = undefined;

    if (currentPreview?.url?.startsWith("blob:")) {
      videoSrc = currentPreview.url;
    } else if (fileName && backendUrl && companyId) {
      videoSrc = `${backendUrl}/public/company${companyId}/${fileName}`;
    }

    return (
      <div
        key={`video-${number}`}
        className={`stackVideo${number}`}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          backgroundColor:
            theme.palette.type === "dark"
              ? "rgba(255, 255, 255, 0.05)"
              : "rgba(0, 0, 0, 0.03)",
          padding: "16px",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <Typography variant="subtitle2" style={{ fontWeight: 500 }}>
            Video
          </Typography>
          <IconButton
            onClick={() => handleRemoveElement("video", number)}
            style={{ padding: "4px" }}
          >
            <Delete style={{ fontSize: "16px" }} />
          </IconButton>
        </div>

        <input
          accept="video/*"
          id={`videoFile${number}`}
          type="file"
          style={{ display: "none" }}
          onChange={(e) => handleFileChange(e, "video", number)}
        />

        <Box style={{ display: "flex", justifyContent: "center" }}>
          <label
            htmlFor={`videoFile${number}`}
            style={{ cursor: "pointer", width: "100%" }}
          >
            {videoSrc ? (
              <video
                controls
                src={videoSrc}
                style={{
                  width: "100%",
                  maxHeight: "240px",
                  display: "block",
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: "4px",
                }}
                preload="metadata"
              />
            ) : (
              <Avatar
                variant="rounded"
                style={{
                  width: 128,
                  height: 128,
                  backgroundColor: theme.palette.action.hover,
                  border: `1px solid ${theme.palette.divider}`,
                  margin: "0 auto",
                }}
              >
                <VideoIcon
                  style={{
                    color: theme.palette.action.active,
                    width: 64,
                    height: 64,
                  }}
                />
              </Avatar>
            )}
          </label>
        </Box>
        <Typography variant="caption" align="center" style={{ marginTop: "8px" }}>
          {fileName || "Clique para selecionar um video"}
        </Typography>
      </div>
    );
  };

  const fileLayout = (number, valueDefault = "") => {
    const currentPreview = previewFiles.find((p) => p.number === number);
    const fileName = currentPreview?.name || valueDefault;
    let fileUrl = undefined;

    if (fileName && backendUrl && companyId) {
      fileUrl = `${backendUrl}/public/company${companyId}/${fileName}`;
    }

    return (
      <div
        key={`file-${number}`}
        className={`stackFile${number}`}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          backgroundColor:
            theme.palette.type === "dark"
              ? "rgba(255, 255, 255, 0.05)"
              : "rgba(0, 0, 0, 0.03)",
          padding: "16px",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <Typography variant="subtitle2" style={{ fontWeight: 500 }}>
            Arquivo
          </Typography>
          <IconButton
            onClick={() => handleRemoveElement("file", number)}
            style={{ padding: "4px" }}
          >
            <Delete style={{ fontSize: "16px" }} />
          </IconButton>
        </div>
        <input
          accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip"
          style={{ display: "none" }}
          id={`file-upload-${number}`}
          type="file"
          onChange={(e) => handleFileChange(e, "file", number)}
        />

        <Box style={{ display: "flex", justifyContent: "center" }}>
          <label
            htmlFor={`file-upload-${number}`}
            style={{ cursor: "pointer", width: "100%" }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 16,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: "4px",
                backgroundColor: theme.palette.background.paper,
              }}
            >
              <Avatar
                variant="rounded"
                style={{
                  width: 48,
                  height: 48,
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                  color: "#757575",
                  marginBottom: theme.spacing(1),
                }}
              >
                <InsertDriveFileOutlined />
              </Avatar>

              {fileName ? (
                <>
                  <Typography
                    variant="body2"
                    align="center"
                    style={{
                      marginBottom: theme.spacing(0.5),
                      wordBreak: "break-word",
                    }}
                  >
                    {fileName}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Clique para substituir
                  </Typography>
                  {fileUrl && (
                    <Button
                      variant="text"
                      size="small"
                      href={fileUrl}
                      target="_blank"
                      style={{ marginTop: 8 }}
                      startIcon={<CloudUpload fontSize="small" />}
                    >
                      Download
                    </Button>
                  )}
                </>
              ) : (
                <>
                  <Typography
                    variant="caption"
                    align="center"
                    style={{ marginBottom: theme.spacing(0.5) }}
                  >
                    Clique para selecionar um arquivo
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    PDF, DOC, XLS, TXT, CSV, ZIP (Max. 10MB)
                  </Typography>
                </>
              )}
            </Box>
          </label>
        </Box>
      </div>
    );
  };

  // Processar elementos para salvar
  const handleElements = (fileNameMap) => {
    const elementsSequence = [];

    elementsSeq.forEach((item) => {
      const elementInput = document.querySelector(
        `.${item} .MuiInputBase-input`
      );

      if (item.includes("message")) {
        const value = elementInput?.value;
        if (!value) {
          toast.error("Campos de mensagem vazio!");
          throw new Error("Campos de mensagem vazio!");
        }
        elementsSequence.push({ type: "message", value, number: item });
      } else if (item.includes("interval")) {
        const value = elementInput?.value;
        const numericValue = parseInt(value || "0", 10);
        if (!value || numericValue <= 0 || numericValue > 120) {
          toast.error("Intervalo invalido! Deve ser entre 1 e 120 segundos.");
          throw new Error("Intervalo invalido!");
        }
        elementsSequence.push({ type: "interval", value, number: item });
      } else if (item.includes("img")) {
        const itemNumber = parseInt(item.replace("img", ""), 10);
        let finalFileName = "";
        let originalName = "";

        const existingElement = elementsEdit.find((el) => el.number === item);
        if (existingElement) {
          finalFileName = existingElement.value;
          originalName = existingElement.original || existingElement.value;
        } else {
          const preview = previewImg.find((p) => p.number === itemNumber);
          if (!preview) {
            toast.error(`Imagem para o elemento ${item} nao encontrada!`);
            throw new Error(`Imagem ${item} nao encontrada!`);
          }
          originalName = preview.name;
          finalFileName = fileNameMap[originalName] || originalName;
        }

        elementsSequence.push({
          type: "img",
          value: finalFileName,
          number: item,
          original: originalName,
        });
      } else if (item.includes("audio")) {
        const itemNumber = parseInt(item.replace("audio", ""), 10);
        let finalFileName = "";
        let originalName = "";
        let isRecording = false;

        const existingElement = elementsEdit.find((el) => el.number === item);
        if (existingElement) {
          finalFileName = existingElement.value;
          originalName = existingElement.original || existingElement.value;
          isRecording = existingElement.record || false;
        } else {
          const preview = previewAudios.find((p) => p.number === itemNumber);
          if (!preview) {
            toast.error(`Audio para o elemento ${item} nao encontrado!`);
            throw new Error(`Audio ${item} nao encontrado!`);
          }
          originalName = preview.name;
          finalFileName = fileNameMap[originalName] || originalName;
          const recordInput = document.querySelector(
            `.checkaudio${itemNumber} input[type=checkbox]`
          );
          isRecording = recordInput?.checked || false;
        }

        elementsSequence.push({
          type: "audio",
          value: finalFileName,
          number: item,
          original: originalName,
          record: isRecording,
        });
      } else if (item.includes("video")) {
        const itemNumber = parseInt(item.replace("video", ""), 10);
        let finalFileName = "";
        let originalName = "";

        const existingElement = elementsEdit.find((el) => el.number === item);
        if (existingElement) {
          finalFileName = existingElement.value;
          originalName = existingElement.original || existingElement.value;
        } else {
          const preview = previewVideos.find((p) => p.number === itemNumber);
          if (!preview) {
            toast.error(`Video para o elemento ${item} nao encontrado!`);
            throw new Error(`Video ${item} nao encontrado!`);
          }
          originalName = preview.name;
          finalFileName = fileNameMap[originalName] || originalName;
        }

        elementsSequence.push({
          type: "video",
          value: finalFileName,
          number: item,
          original: originalName,
        });
      } else if (item.includes("file")) {
        const itemNumber = parseInt(item.replace("file", ""), 10);
        let finalFileName = "";
        let originalName = "";

        const existingElement = elementsEdit.find((el) => el.number === item);
        if (existingElement) {
          finalFileName = existingElement.value;
          originalName = existingElement.original || existingElement.value;
        } else {
          const preview = previewFiles.find((p) => p.number === itemNumber);
          if (!preview) {
            toast.error(`Arquivo para o elemento ${item} nao encontrado!`);
            throw new Error(`Arquivo ${item} nao encontrado!`);
          }
          originalName = preview.name;
          finalFileName = fileNameMap[originalName] || originalName;
        }

        elementsSequence.push({
          type: "file",
          value: finalFileName,
          original: originalName,
          number: item,
        });
      }
    });

    return elementsSequence;
  };

  // Salvar
  const handleSaveNode = async () => {
    if (phoneNumbers.length === 0 && !useGroup && !selectedTags.length) {
      toast.error("Adicione pelo menos um numero de telefone ou selecione tags");
      return;
    }

    if (useGroup && !groupName) {
      toast.error("Informe o nome do grupo");
      return;
    }

    if (elementsSeq.length === 0) {
      toast.error("Adicione pelo menos um elemento de conteudo");
      return;
    }

    setLoading(true);
    const fileNameMap = {};

    try {
      // Filtrar arquivos para upload
      const filesToUpload = medias.filter((file) => {
        const existingFile = elementsEdit.some(
          (el) =>
            (el.type === "img" ||
              el.type === "audio" ||
              el.type === "video" ||
              el.type === "file") &&
            (el.value === file.name || el.original === file.name)
        );
        return !existingFile;
      });

      if (filesToUpload.length > 0) {
        const formData = new FormData();
        const originalNamesForUpload = [];

        filesToUpload.forEach((media) => {
          formData.append("medias", media);
          originalNamesForUpload.push(media.name);
        });

        const { data: uploadResponse } = await api.post(
          "/flowbuilder/content",
          formData
        );

        if (
          !uploadResponse ||
          uploadResponse.length !== originalNamesForUpload.length
        ) {
          throw new Error("Erro ao enviar arquivos de midia");
        }

        originalNamesForUpload.forEach((originalName, index) => {
          fileNameMap[originalName] = uploadResponse[index];
        });
      } else {
        // Mapear arquivos existentes
        [
          ...previewFiles,
          ...previewImg,
          ...previewAudios,
          ...previewVideos,
        ].forEach((preview) => {
          fileNameMap[preview.name] = preview.name;
        });
      }

      const elementsData = handleElements(fileNameMap);

      const nodeData = {
        seq: elementsSeq,
        elements: elementsData,
        phoneNumbers: useGroup ? [] : phoneNumbers,
        groupName: useGroup ? groupName : undefined,
        ...(selectedWhatsappId ? { whatsappId: selectedWhatsappId } : {}),
        tagIds:
          selectedTags.length > 0 ? selectedTags.map((tag) => tag.id) : undefined,
        tags: selectedTags.length > 0 ? selectedTags : undefined,
      };

      if (open === "create") {
        onSave(nodeData);
      } else if (open === "edit" && data) {
        onUpdate({
          ...data,
          data: nodeData,
        });
      }

      resetState();
      setActiveModal(false);
      close(null);
    } catch (error) {
      console.error("Erro ao salvar node:", error);
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      toast.error(`Erro ao salvar node: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  // Drag and drop handler
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const newElements = [...elements];
    const newElementsSeq = [...elementsSeq];

    const [movedElement] = newElements.splice(result.source.index, 1);
    const [movedSeq] = newElementsSeq.splice(result.source.index, 1);

    newElements.splice(result.destination.index, 0, movedElement);
    newElementsSeq.splice(result.destination.index, 0, movedSeq);

    setElements(newElements);
    setElementsSeq(newElementsSeq);
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
      PaperProps={{
        style: {
          maxHeight: "calc(100% - 64px)",
          overflowY: "auto",
        },
      }}
    >
      <DialogTitle>{labels.title}</DialogTitle>
      <DialogContent>
        <Box style={{ marginBottom: 16 }}>
          <Typography variant="subtitle1" gutterBottom>
            Configuracoes de Envio
          </Typography>

          {/* Selecao de conexao WhatsApp */}
          <Box style={{ marginBottom: 16 }}>
            <Typography variant="subtitle2" gutterBottom>
              Selecione a conexao WhatsApp para envio
            </Typography>
            <TextField
              select
              fullWidth
              label="Conexao WhatsApp"
              value={selectedWhatsappId || ""}
              onChange={(e) =>
                setSelectedWhatsappId(
                  e.target.value ? Number(e.target.value) : undefined
                )
              }
              variant="outlined"
              margin="dense"
              helperText="Selecione a conexao WhatsApp que sera usada para enviar as mensagens"
            >
              <MenuItem value="">
                <em>Usar conexao padrao</em>
              </MenuItem>
              {whatsappConnections.map((connection) => (
                <MenuItem key={connection.id} value={connection.id}>
                  {connection.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {/* Selecao de Tags */}
          <Box style={{ marginBottom: 16 }}>
            <Typography variant="subtitle2" gutterBottom>
              Selecione as tags para os contatos
            </Typography>
            <Autocomplete
              multiple
              size="small"
              options={tags}
              loading={loadingTags}
              value={selectedTags}
              onChange={(_, newValue) => setSelectedTags(newValue)}
              getOptionLabel={(option) => option.name}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={option.id}
                    variant="outlined"
                    style={{
                      backgroundColor: option.color || "#eee",
                      textShadow: "1px 1px 1px #000",
                      color: "white",
                    }}
                    label={option.name}
                    {...getTagProps({ index })}
                    size="small"
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Selecione as tags"
                  helperText="As mensagens ativas serao aplicadas a contatos com estas tags"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingTags ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Box>

          {/* Destinatarios */}
          <Box style={{ marginBottom: 16 }}>
            <Typography variant="subtitle2" gutterBottom>
              Selecione os destinatarios
            </Typography>

            <Box style={{ display: "flex", alignItems: "flex-start", marginTop: 16 }}>
              <FormControl
                variant="outlined"
                fullWidth
                style={{ marginRight: 8 }}
              >
                <Autocomplete
                  freeSolo
                  value={selectedContact}
                  options={contacts}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") return option;
                    return option.name
                      ? `${option.name} (${option.number})`
                      : option.number;
                  }}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      setPhoneNumberInput(newValue);
                      setSelectedContact(null);
                    } else {
                      setSelectedContact(newValue);
                      if (newValue) setPhoneNumberInput(newValue.number);
                      else setPhoneNumberInput("");
                    }
                  }}
                  onInputChange={(event, value) => {
                    setPhoneNumberInput(value);
                    searchContacts(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Numero de telefone ou nome do contato"
                      variant="outlined"
                      placeholder="Busque por numero ou nome de contato"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <PhoneAndroid />
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                        endAdornment: (
                          <>
                            {loadingContacts ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          addPhoneNumber();
                        }
                      }}
                    />
                  )}
                  renderOption={(option) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div>
                        <div style={{ fontWeight: 500 }}>
                          {option.name || "Sem nome"}
                        </div>
                        <div
                          style={{
                            fontSize: "0.8rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        >
                          {option.number}
                        </div>
                      </div>
                    </div>
                  )}
                />
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                onClick={addPhoneNumber}
                style={{ minWidth: "120px", height: "56px" }}
              >
                <Add /> Adicionar
              </Button>
            </Box>

            <Box
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                marginTop: "16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  startIcon={<ImportContacts />}
                  style={{ marginRight: "12px", flexShrink: 0 }}
                >
                  Importar Lista
                  <input
                    type="file"
                    accept=".csv,.txt"
                    style={{ display: "none" }}
                    onChange={importPhoneNumbers}
                  />
                </Button>

                <div
                  style={{
                    display: "flex",
                    backgroundColor: "rgba(25, 118, 210, 0.08)",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    flex: 1,
                    border: "1px solid rgba(25, 118, 210, 0.3)",
                  }}
                >
                  <InfoOutlined
                    style={{
                      fontSize: "16px",
                      color: "#1976d2",
                      marginRight: "8px",
                      flexShrink: 0,
                      marginTop: "2px",
                    }}
                  />
                  <Typography
                    variant="caption"
                    style={{ color: "rgba(0, 0, 0, 0.7)", lineHeight: 1.3 }}
                  >
                    Formatos: .csv ou .txt com um numero por linha no formato
                    internacional (Ex: 5511981234567), sem espacos ou caracteres
                    especiais.
                  </Typography>
                </div>

                {phoneNumbers.length > 0 && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => setPhoneNumbers([])}
                    style={{ marginLeft: "12px", flexShrink: 0 }}
                  >
                    Limpar Todos
                  </Button>
                )}
              </div>
            </Box>

            {phoneNumbers.length > 0 && (
              <Paper
                variant="outlined"
                style={{
                  marginTop: "16px",
                  padding: "8px",
                  maxHeight: "150px",
                  overflowY: "auto",
                }}
              >
                <Typography variant="subtitle2" gutterBottom>
                  {phoneNumbers.length} numero(s) adicionado(s)
                </Typography>
                <Box style={{ display: "flex", flexWrap: "wrap" }}>
                  {phoneNumbers.map((number) => (
                    <Chip
                      key={number}
                      label={number}
                      onDelete={() => removePhoneNumber(number)}
                      size="small"
                      color="primary"
                      variant="outlined"
                      style={{ margin: "4px" }}
                    />
                  ))}
                </Box>
              </Paper>
            )}
          </Box>
        </Box>

        <Divider style={{ margin: "24px 0" }} />

        <Typography variant="h6" gutterBottom>
          Conteudo da Mensagem
        </Typography>

        <Box style={{ display: "flex", marginBottom: "16px" }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<MessageOutlined />}
            onClick={() => {
              const n = numberMessagesLast;
              setElements((o) => [...o, messageLayout(n)]);
              setElementsSeq((o) => [...o, `message${n}`]);
              setNumberMessages((o) => o + 1);
              setNumberMessagesLast((o) => o + 1);
            }}
            style={{ marginRight: "16px" }}
          >
            Texto
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Timer />}
            onClick={() => {
              const n = numberIntervalLast;
              setElements((o) => [...o, intervalLayout(n)]);
              setElementsSeq((o) => [...o, `interval${n}`]);
              setNumberInterval((o) => o + 1);
              setNumberIntervalLast((o) => o + 1);
            }}
            style={{ marginRight: "16px" }}
          >
            Intervalo
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AttachFile />}
            onClick={(e) => setMediaMenuAnchor(e.currentTarget)}
          >
            Midia
          </Button>
          <Menu
            anchorEl={mediaMenuAnchor}
            open={Boolean(mediaMenuAnchor)}
            onClose={() => setMediaMenuAnchor(null)}
          >
            <MenuItem
              onClick={() => {
                const n = numberImgLast;
                setElements((o) => [...o, imgLayout(n)]);
                setElementsSeq((o) => [...o, `img${n}`]);
                setNumberImg((o) => o + 1);
                setNumberImgLast((o) => o + 1);
                setMediaMenuAnchor(null);
              }}
            >
              <ImageIcon fontSize="small" style={{ marginRight: 8 }} /> Imagem
            </MenuItem>
            <MenuItem
              onClick={() => {
                const n = numberAudioLast;
                setElements((o) => [...o, audioLayout(n)]);
                setElementsSeq((o) => [...o, `audio${n}`]);
                setNumberAudio((o) => o + 1);
                setNumberAudioLast((o) => o + 1);
                setMediaMenuAnchor(null);
              }}
            >
              <MicNone fontSize="small" style={{ marginRight: 8 }} /> Audio
            </MenuItem>
            <MenuItem
              onClick={() => {
                const n = numberVideoLast;
                setElements((o) => [...o, videoLayout(n)]);
                setElementsSeq((o) => [...o, `video${n}`]);
                setNumberVideo((o) => o + 1);
                setNumberVideoLast((o) => o + 1);
                setMediaMenuAnchor(null);
              }}
            >
              <Videocam fontSize="small" style={{ marginRight: 8 }} /> Video
            </MenuItem>
            <MenuItem
              onClick={() => {
                const n = numberFileLast;
                setElements((o) => [...o, fileLayout(n)]);
                setElementsSeq((o) => [...o, `file${n}`]);
                setNumberFile((o) => o + 1);
                setNumberFileLast((o) => o + 1);
                setMediaMenuAnchor(null);
              }}
            >
              <InsertDriveFile fontSize="small" style={{ marginRight: 8 }} />{" "}
              Arquivo
            </MenuItem>
          </Menu>
        </Box>

        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {elements.map((item, index) => (
                  <Draggable
                    key={elementsSeq[index]}
                    draggableId={elementsSeq[index]}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        {item}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancelar
        </Button>
        <Button
          onClick={handleSaveNode}
          color="primary"
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {labels.btn}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAddActiveMessageModal;
